// String / value formatting helpers.

import { FormGroup } from '@angular/forms';

export function formatPhoneNumber(phone: string): string {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length !== 10) return phone;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function capitalizeFirst(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function capitalizeWordsLongerThan1(str: string): string {
  if (!str) return str;
  return str
    .split(' ')
    .map((word) =>
      word.length > 1
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word,
    )
    .join(' ');
}

export function formatSSNDigits(digits: string): string {
  const d = digits.replace(/\D/g, '').slice(0, 9);
  if (d.length > 5) return `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}`;
  if (d.length > 3) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return d;
}

export function formatEventValue(value: any): string {
  if (value) {
    let jsonString = JSON.stringify(value);
    jsonString = jsonString.replace(/[{}"]/g, ''); // Remove curly braces and double quotes
    jsonString = jsonString.replace(/:/g, ': '); // Add space after colon
    jsonString = jsonString.replace(/,/g, ', '); // Add space after comma
    return jsonString;
  } else {
    return '';
  }
}

export function extractTrailingNumbers(str: string): string {
  if (!str) return '';

  const match = str.match(/\d+$/);
  return match ? match[0] : '';
}

export function toUpperCaseObject<T extends Record<string, any>>(obj: T): T {
  const result: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    result[key] =
      typeof obj[key] === 'string' ? obj[key].toUpperCase() : obj[key];
  });
  return result as T;
}

export function allEntriesToUpperCase(form: FormGroup) {
  // need to make flexible for all forms
  const controls = form;
  for (const name in controls) {
    if (controls.hasOwnProperty(name)) {
      const control = controls[name];
      control.setValue(control.value.toUpperCase());
    }
  }
  return controls;
}
